var _defs, _g, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#999;}.cls-3{fill:none;stroke:#999;stroke-linecap:round;stroke-linejoin:round;stroke-width:.7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,8.9v7c0,.6,.2,1.1,.6,1.5s.9,.6,1.5,.6H15.9c.6,0,1.1-.2,1.5-.6,.4-.4,.6-.9,.6-1.5v-7H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,4.8L13.4,0V3.3c0,.4,.2,.8,.4,1.1,.3,.3,.7,.4,1.1,.4h3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.9,12.1H0V2.1C0,1.6,.2,1.1,.6,.7,.9,.3,1.4,0,2,0H12.5V.9H2c-.3,0-.6,.1-.8,.4-.2,.2-.3,.5-.3,.8V12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.1,5.6h.9v6.4h-.9V5.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6 15 4.2 15 4.2 11.8 5 11.8 5 14.3 6 14.3 6 15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.5,14.6c-.3,.4-.8,.6-1.3,.6-.5,0-.9-.1-1.3-.5-.3-.3-.5-.8-.5-1.2,0-.2,0-.4,.1-.6,.1-.3,.3-.6,.6-.8,.3-.2,.7-.3,1-.3,.5,0,.9,.1,1.3,.5,.3,.3,.5,.8,.5,1.2,0,.4-.2,.8-.4,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.8,13.9c-.1,.2-.4,.3-.6,.2-.2,0-.4,0-.6-.2-.1-.1-.2-.3-.2-.5,0,0,0-.2,0-.3,0-.1,.2-.3,.3-.4,.1,0,.3-.1,.4-.1,.2,0,.4,0,.6,.2,.1,.1,.2,.3,.2,.5,0,.2,0,.4-.2,.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.7,14.1c-.1,.3-.3,.6-.6,.8-.3,.2-.6,.3-.9,.3-.5,0-1-.2-1.4-.6-.2-.3-.4-.7-.4-1.1,0-.4,.2-.8,.4-1.1,.3-.4,.8-.6,1.3-.5,.3,0,.7,0,1,.3,.2,.2,.4,.4,.5,.6l-.8,.3c0-.1-.1-.2-.2-.3-.1-.1-.3-.2-.5-.2-.2,0-.3,0-.5,.2-.1,.1-.2,.2-.3,.4,0,.1,0,.3,0,.4,0,.3,.1,.6,.3,.8,.1,.2,.4,.2,.6,.2,.2,0,.4,0,.5-.2,0,0,.1-.2,.2-.4h-.7v-.6h1.7c0,.3,0,.6-.1,.9h0Z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3.4,
    y1: 4.3,
    x2: 11.4,
    y2: 4.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3.4,
    y1: 5.8,
    x2: 11.4,
    y2: 5.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3.4,
    y1: 7.4,
    x2: 11.4,
    y2: 7.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.7a09e8c620ac51e4d8a02207bb84406e.svg";
export { ForwardRef as ReactComponent };